import {ApolloLink, NextLink, Operation} from '@apollo/client';

import * as csrf from 'CSRF';

import {isMutation} from './AST';

interface OperationContext {
  headers?: Record<string, string>;
}

export default function createCsrfLink(): ApolloLink {
  return new ApolloLink((operation: Operation, forward: NextLink | undefined) => {
    if (isMutation(operation.query) && csrf.token != null) {
      operation.setContext(({headers = {}}: OperationContext) => ({
        headers: {
          ...headers,
          'X-CSRFToken': csrf.token,
        },
      }));
    }
    return forward!(operation);
  });
}
